// Configuration
export const CHECK_INTERVAL_MS = 60 * 1000; // Check every 60 seconds
export const REMINDER_WINDOW_MINUTES = 30;  // How many minutes before due time to consider it "due soon"

// Notification type constants - use strings to match server format
export const NOTIFICATION_TYPES = {
  MEDICATION: "120",
  HEALTH_CHECK: "130"
};

// Import notification event name constants from central location
import { NOTIFICATION_EVENTS } from '../eventConstants';
// Re-export for backward compatibility
export { NOTIFICATION_EVENTS }; 